import { Head } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import BillingRecoveryLayout from "@/layouts/billing_recovery_layout";

export default function NoLocation() {
  const { t } = useTranslation();
  return (
    <BillingRecoveryLayout>
      <Head title={t("companies.no_location_title")} />
      <h1 className="text-page font-display">
        {t("companies.no_location_title")}
      </h1>
      <p className="mt-3 text-muted-foreground">
        {t("companies.no_location_description")}
      </p>
    </BillingRecoveryLayout>
  );
}
